import { render, staticRenderFns } from "./customersList.vue?vue&type=template&id=7234d93d&scoped=true"
import script from "./customersList.vue?vue&type=script&lang=js"
export * from "./customersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234d93d",
  null
  
)

export default component.exports